import { render, staticRenderFns } from "./QuestionHome.vue?vue&type=template&id=7f2dc1ba&scoped=true&"
import script from "./QuestionHome.vue?vue&type=script&lang=js&"
export * from "./QuestionHome.vue?vue&type=script&lang=js&"
import style0 from "./QuestionHome.vue?vue&type=style&index=0&id=7f2dc1ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2dc1ba",
  null
  
)

export default component.exports